<script setup>
import { computed } from 'vue'
import { storeAuth as auth } from '@ozdao/martyrs/modules/auth/client'
import IconHome from '@martyrs/src/modules/icons/entities/IconHome.vue'

const isAuth = computed(() => !!auth.state.access.status)
</script>

<template>
  <router-link v-if="isAuth" to="/dashboard" class="button button--light button--m bs-regular d-inline-flex flex-v-center gap-thin">
    <IconHome class="i-regular" fill="currentColor" />
    Дашборд
  </router-link>
  <router-link v-else to="/auth/signin" class="button button--light button--m bs-regular">
    Войти
  </router-link>
</template>
